import * as React from 'react';
const RadioGroupContext = /*#__PURE__*/React.createContext(undefined);
export const RadioGroupContextProvider = RadioGroupContext.Provider;
export default RadioGroupContext;
export const RadioOptionTypeContext = /*#__PURE__*/React.createContext(undefined);
export const RadioOptionTypeContextProvider = RadioOptionTypeContext.Provider;